import { InjectionToken } from '@angular/core';

export interface IErmApiClientConfig {
    ermCapabilityApiBaseUrl?: string;
    ermConsoleApiBaseUrl?: string;
    ermDevOpsApiBaseUrl?: string;

    enableLogging?: boolean;

    authHeaderResolver?: () => Promise<string>;
}

export const ErmApiClientConfig = new InjectionToken<IErmApiClientConfig>('ErmApiClientConfig');
